import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';
import { Keys } from '@oracle/oraclejet-testing/UNSAFE_Driver';
import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';

export class InputTextAdapter extends TestAdapter {
  /**
   * Clear and commit the value of the input element
   * @returns Promise<void>
   */
  async clear() {
    await this.changeValue(undefined);
  }

  /**
   * Change and commit the value of the input element
   * @param value {string | undefined}  The new value
   * @returns Promise<void>
   */
  async changeValue(value: string | undefined) {
    const driver = this.getTestDriver();
    const el = await this.getElement();

    // Find the <input> element underneath the root.
    const input = await el.waitForElement(byCss('input'));

    // Clear any existing value.
    await driver.sendKeys(input, Keys['CONTROL_COMMAND'], 'a');
    await driver.sendKeys(input, Keys['DELETE']);

    // Type the value into <input> and commit it.
    if (value !== undefined) {
      await driver.sendKeys(input, value);
    }

    await driver.sendKeys(input, Keys['ENTER']);
  }
}
